import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import routes from '@root/routes';
import actions from '@store/actions/navigation';
import { StoreState } from '@root/types';
import LogoSvg from '@components/shared/Logo';
import s from '@components/shared/Logo/Logo.module.less';
import { useFlags } from 'launchdarkly-react-client-sdk';

const mapState = ({ currentUser }: StoreState) => ({
  currentUser,
});

const mapDispatch = {
  navLogoClicked: () => actions.navLogoClicked(),
};

const connector = connect(mapState, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

const Logo = ({ currentUser = null, navLogoClicked }: ReduxProps) => {
  const flags = useFlags();
  return (
    <div className={s.logoNavigationLink}>
      {currentUser ? (
        <Link
          data-testid="homeLink"
          className={flags['search-redesign'] ? s.redesignLogo : s.logo}
          to={routes.root}
          onClick={navLogoClicked}
        >
          <LogoSvg />
        </Link>
      ) : (
        <div className={flags['search-redesign'] ? s.redesignLogo : s.logo}>
          <LogoSvg />
        </div>
      )}
    </div>
  );
};

export default connector(Logo);
